var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { sheetRowsApi } from '@data/rest/api';
import { useTagContext } from '@data/tag/tagContext';
import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TagType, } from '../../../../../common/api';
import { sheetRowKeys, useCreateSheetRow, useDeleteSheetRow, useDuplicateSheetRow, useMaterializeSheetRowBranch, useMoveSheetRow, useSheetRows, useSheetRowSearch, useSheetRowsSearch, useUpdateSheetRow, } from '../sheetRow/sheetRowActions';
import { createExtendedSheetRow, SheetRowPath } from './sheetRow';
//@ts-ignore
import { useBranch } from 'baobab-react/hooks';
import { PathTree } from './sheetRowPath';
export function useSheetRowPath() {
    var _a = useParams().clusterPath, clusterPath = _a === void 0 ? '0' : _a;
    var sheetRowPath = useMemo(function () { return new SheetRowPath(clusterPath); }, [clusterPath]);
    return sheetRowPath;
}
export function useSelectedSheetRow() {
    var sheetRowPath = useSheetRowPath();
    var selectedSheetRowPath = useBranch({ selectedSheetRowPath: ['state', 'selectedRowPath'] }).selectedSheetRowPath;
    var targetSheetRowPath = selectedSheetRowPath ? new SheetRowPath(selectedSheetRowPath) : sheetRowPath;
    var _a = useTagContext(), tagData = _a.tagData, tagsLoading = _a.tagsLoading;
    var sheetRowsById = useSheetRowsById();
    var data = useSheetRowSearch(targetSheetRowPath.toString(), { notifyOnChangeProps: ['data'] }).data;
    if (tagsLoading || (data === null || data === void 0 ? void 0 : data.current) === undefined) {
        return;
    }
    var sheetRow = sheetRowsById[data.current.id];
    if (!sheetRow) {
        return;
    }
    return createExtendedSheetRow(targetSheetRowPath, data.current, sheetRow, tagData.tagById);
}
export function useSheetRowsById() {
    var data = useSheetRows({
        notifyOnChangeProps: ['data'],
    }).data;
    return useMemo(function () {
        var e_1, _a;
        var map = {};
        if (!data) {
            return map;
        }
        try {
            for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
                var sheetRow = data_1_1.value;
                map[sheetRow.id] = sheetRow;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return map;
    }, [data]);
}
export function useSheetRowsByParentId() {
    var data = useSheetRows({
        notifyOnChangeProps: ['data'],
    }).data;
    return useMemo(function () {
        var e_2, _a;
        var _b, _c;
        var map = {};
        if (!data) {
            return map;
        }
        try {
            for (var data_2 = __values(data), data_2_1 = data_2.next(); !data_2_1.done; data_2_1 = data_2.next()) {
                var sheetRow = data_2_1.value;
                var children = map[(_b = sheetRow.parentId) !== null && _b !== void 0 ? _b : 0];
                if (!children) {
                    map[(_c = sheetRow.parentId) !== null && _c !== void 0 ? _c : 0] = children = [];
                }
                children.push(sheetRow);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (data_2_1 && !data_2_1.done && (_a = data_2.return)) _a.call(data_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return map;
    }, [data]);
}
export function useRootSheetRow(path) {
    var _a, _b;
    var sheetRowPath = useSheetRowPath();
    var targetPath = path ? new SheetRowPath(path) : sheetRowPath;
    var parentPath = targetPath.segments[targetPath.segments.length - 2];
    var parentSheetRowPath = new SheetRowPath((_a = parentPath === null || parentPath === void 0 ? void 0 : parentPath.fullPath) !== null && _a !== void 0 ? _a : '0');
    var _c = useTagContext(), tagData = _c.tagData, tagsLoading = _c.tagsLoading;
    var sheetRowsById = useSheetRowsById();
    var parentData = useSheetRowSearch(parentSheetRowPath.toString(), {
        notifyOnChangeProps: ['data'],
    }).data;
    var data = useSheetRowSearch(targetPath.toString(), { notifyOnChangeProps: ['data'] }).data;
    if (tagsLoading || (data === null || data === void 0 ? void 0 : data.current) === undefined) {
        return null;
    }
    //when selected root row has no children take create sheet row branch from its parent path
    var targetRootSheetRow = data.current.hasChildren ? data.current : (_b = parentData === null || parentData === void 0 ? void 0 : parentData.current) !== null && _b !== void 0 ? _b : data.current;
    var sheetRow = sheetRowsById[targetRootSheetRow.id];
    if (!sheetRow) {
        return null;
    }
    var targetRootPath = new SheetRowPath(targetRootSheetRow.path);
    return createExtendedSheetRow(targetRootPath, targetRootSheetRow, sheetRow, tagData.tagById);
}
export function useSheetRowBranch(rootSheetRowPath, tagMap, sheetRowMap, expandedPaths, expressions, withDataMap, numberColumnsData) {
    var _a = useMemo(function () {
        var e_3, _a;
        var tree = new PathTree();
        try {
            for (var expandedPaths_1 = __values(expandedPaths), expandedPaths_1_1 = expandedPaths_1.next(); !expandedPaths_1_1.done; expandedPaths_1_1 = expandedPaths_1.next()) {
                var expandedPath = expandedPaths_1_1.value;
                var path = new SheetRowPath(expandedPath);
                tree.insert(path);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (expandedPaths_1_1 && !expandedPaths_1_1.done && (_a = expandedPaths_1.return)) _a.call(expandedPaths_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        var paths = tree.findAllToMap(rootSheetRowPath.getPath());
        // rootSheetRowPath is always expanded
        paths.set(rootSheetRowPath.toString(), rootSheetRowPath);
        var searchQueries = Array.from(paths.values()).map(function (p) { return ({
            path: p.toString(),
            numberColumnsData: numberColumnsData,
            withDataChildren: withDataMap === null || withDataMap === void 0 ? void 0 : withDataMap.get(p.sheetRowId),
            withDataCompoundExpression: expressions === null || expressions === void 0 ? void 0 : expressions.withDataCompoundExpression,
            filterCompoundExpression: expressions === null || expressions === void 0 ? void 0 : expressions.filterCompoundExpression,
        }); });
        return { searchQueries: searchQueries, paths: paths };
    }, [expandedPaths, rootSheetRowPath, withDataMap]), paths = _a.paths, searchQueries = _a.searchQueries;
    var searchResults = useSheetRowsSearch(searchQueries);
    var areLoading = searchResults.reduce(function (loading, r) { return loading || r.isLoading; }, false);
    var searchResultMap = new Map(searchResults.map(function (searchResult) { var _a; return [(_a = searchResult.data) === null || _a === void 0 ? void 0 : _a.path, searchResult.data]; }));
    var sheetRows = [];
    function traverseTree(pathStr, depth) {
        var e_4, _a, e_5, _b;
        var _c;
        var result = searchResultMap.get(pathStr);
        var path = paths.get(pathStr);
        if (!result || !path) {
            return;
        }
        if (result.current) {
            var sheetRow = sheetRowMap[(_c = result.current.id) !== null && _c !== void 0 ? _c : 0];
            if (sheetRow) {
                var sr = createExtendedSheetRow(path, result.current, sheetRow, tagMap, depth, true);
                sheetRows.push(sr);
            }
        }
        try {
            for (var _d = __values(result.children), _e = _d.next(); !_e.done; _e = _d.next()) {
                var row = _e.value;
                var sheetRow = sheetRowMap[row.id];
                if (!sheetRow) {
                    continue;
                }
                var sheetRowPath = new SheetRowPath(row.path);
                if (row.tableTagId === null) {
                    if (paths.has(row.path)) {
                        traverseTree(row.path, depth + 1);
                    }
                    else {
                        var sr = createExtendedSheetRow(sheetRowPath, row, sheetRow, tagMap, depth + 1, false);
                        sheetRows.push(sr);
                    }
                    continue;
                }
                if (!row.generated.length) {
                    var sr = createExtendedSheetRow(sheetRowPath, row, sheetRow, tagMap, depth + 1, false);
                    // evaluator should return empty cells
                    sheetRows.push(__assign(__assign({}, sr), { allTags: [], dimensions: [], variable: undefined, generatedTag: undefined, generatedTagId: undefined, usedTagId: undefined, name: 'No result', hasChildren: false }));
                    continue;
                }
                try {
                    for (var _f = (e_5 = void 0, __values(row.generated)), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var tagId = _g.value;
                        var tag = tagMap[tagId];
                        if (!tag) {
                            continue;
                        }
                        var generatedPath = row.path + ':' + tag.id;
                        if (paths.has(generatedPath)) {
                            traverseTree(generatedPath, depth + 1);
                        }
                        else {
                            var sheetRowPath_1 = new SheetRowPath(generatedPath);
                            var sr = createExtendedSheetRow(sheetRowPath_1, row, sheetRow, tagMap, depth + 1, false);
                            sheetRows.push(sr);
                        }
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_4) throw e_4.error; }
        }
    }
    traverseTree(rootSheetRowPath.toString(), 0);
    return [sheetRows, areLoading];
}
export function useSheetRowActions() {
    var _this = this;
    var queryClient = useQueryClient();
    var sheetRowsById = useSheetRowsById();
    var sheetRowsByParentId = useSheetRowsByParentId();
    var update = useUpdateSheetRow();
    var add = useCreateSheetRow();
    var remove = useDeleteSheetRow();
    var duplicate = useDuplicateSheetRow();
    var materialize = useMaterializeSheetRowBranch();
    var move = useMoveSheetRow();
    var path = useSheetRowPath();
    var navigate = useNavigate();
    var batchUpdate = function (sheetRows) { return __awaiter(_this, void 0, void 0, function () {
        var sheetRows_1, sheetRows_1_1, sheetRow, e_6_1;
        var e_6, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, 6, 7]);
                    sheetRows_1 = __values(sheetRows), sheetRows_1_1 = sheetRows_1.next();
                    _b.label = 1;
                case 1:
                    if (!!sheetRows_1_1.done) return [3 /*break*/, 4];
                    sheetRow = sheetRows_1_1.value;
                    return [4 /*yield*/, sheetRowsApi.update(sheetRow.id, sheetRow)];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    sheetRows_1_1 = sheetRows_1.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_6_1 = _b.sent();
                    e_6 = { error: e_6_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (sheetRows_1_1 && !sheetRows_1_1.done && (_a = sheetRows_1.return)) _a.call(sheetRows_1);
                    }
                    finally { if (e_6) throw e_6.error; }
                    return [7 /*endfinally*/];
                case 7:
                    queryClient.invalidateQueries(sheetRowKeys.all);
                    return [2 /*return*/];
            }
        });
    }); };
    var createSheetRow = function (sheetRow) { return __awaiter(_this, void 0, void 0, function () {
        var parent, cls;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    parent = sheetRow.parentId ? sheetRowsById[sheetRow.parentId] : null;
                    sheetRow.readonly = parent ? parent.readonly : false;
                    return [4 /*yield*/, add.mutateAsync(__assign({}, sheetRow))];
                case 1:
                    cls = _a.sent();
                    return [2 /*return*/, cls];
            }
        });
    }); };
    var createSheetRowTag = function (sheetRow, tagName, tagData, createTag) { return __awaiter(_this, void 0, void 0, function () {
        var tag, newDims, newAcc;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tag = tagData.getTagByNameAndParent(tagName, null);
                    if (!!tag) return [3 /*break*/, 2];
                    return [4 /*yield*/, createTag({ name: tagName, ParentId: null, description: '' })];
                case 1:
                    tag = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!tag) {
                        return [2 /*return*/]; // unable to create tag
                    }
                    if (sheetRow.dimensionTagIds.some(function (id) { return id === (tag === null || tag === void 0 ? void 0 : tag.id); }) || sheetRow.accountTagId === tag.id) {
                        return [2 /*return*/]; // tag already exists
                    }
                    newDims = sheetRow.dimensionTagIds;
                    newAcc = sheetRow.accountTagId;
                    if (tag.type === TagType.Account) {
                        newAcc = tag.id;
                    }
                    else {
                        newDims.push(tag.id);
                    }
                    return [4 /*yield*/, update.mutateAsync(__assign(__assign({}, sheetRow), { dimensionTagIds: newDims, accountTagId: newAcc }))];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var selectSheetRowTag = function (sheetRow, tag) { return __awaiter(_this, void 0, void 0, function () {
        var newDims, newAcc;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!tag) {
                        return [2 /*return*/];
                    }
                    if (sheetRow.dimensionTagIds.some(function (id) { return id === (tag === null || tag === void 0 ? void 0 : tag.id); }) || sheetRow.accountTagId === tag.id) {
                        return [2 /*return*/]; // tag already exists
                    }
                    newDims = sheetRow.dimensionTagIds;
                    newAcc = sheetRow.accountTagId;
                    if (tag.type === TagType.Account) {
                        newAcc = tag.id;
                    }
                    else {
                        newDims.push(tag.id);
                    }
                    return [4 /*yield*/, update.mutateAsync(__assign(__assign({}, sheetRow), { dimensionTagIds: newDims, accountTagId: newAcc }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var removeSheetRowTag = function (sheetRow, tagId) { return __awaiter(_this, void 0, void 0, function () {
        var dimensionTagIds;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dimensionTagIds = (_a = sheetRow.dimensionTagIds) === null || _a === void 0 ? void 0 : _a.filter(function (id) { return id !== tagId; });
                    return [4 /*yield*/, update.mutateAsync(__assign(__assign({}, sheetRow), { dimensionTagIds: dimensionTagIds, accountTagId: sheetRow.accountTagId === tagId ? null : sheetRow.accountTagId }))];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var dndReorderSheetRows = function (itemId, newParentId, destinationIdx) { return __awaiter(_this, void 0, void 0, function () {
        var parentId;
        return __generator(this, function (_a) {
            parentId = Number.isNaN(newParentId) ? null : newParentId;
            move.mutate({ id: itemId, parentId: parentId === 0 ? null : parentId, order: destinationIdx });
            return [2 /*return*/];
        });
    }); };
    var dndChangeSheetRowParent = function (sheetRowId, newParentId, destinationIdx) { return __awaiter(_this, void 0, void 0, function () {
        var newParent, sheetRow, getDescendants, descendantIds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (sheetRowId === newParentId) {
                        return [2 /*return*/];
                    }
                    queryClient.cancelQueries(sheetRowKeys.all);
                    newParent = Number.isNaN(newParentId) || newParentId === 0 ? null : newParentId;
                    sheetRow = sheetRowsById[sheetRowId];
                    if (sheetRow === undefined) {
                        return [2 /*return*/];
                    }
                    getDescendants = function (row, set) {
                        var e_7, _a;
                        var _b;
                        if (set.size === 0) {
                            set.add(row.id);
                        }
                        var children = sheetRowsByParentId[(_b = row.id) !== null && _b !== void 0 ? _b : 0];
                        try {
                            for (var _c = __values(children !== null && children !== void 0 ? children : []), _d = _c.next(); !_d.done; _d = _c.next()) {
                                var child = _d.value;
                                getDescendants(child, set);
                                set.add(child.id);
                            }
                        }
                        catch (e_7_1) { e_7 = { error: e_7_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                            }
                            finally { if (e_7) throw e_7.error; }
                        }
                        return set;
                    };
                    descendantIds = getDescendants(sheetRow, new Set());
                    if (descendantIds.has(newParentId)) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, move.mutateAsync({ id: sheetRow.id, parentId: newParent === 0 ? null : newParent, order: destinationIdx !== null && destinationIdx !== void 0 ? destinationIdx : 0 }, {
                            onSuccess: function () {
                                var _a;
                                // navigate away from current path to its parent when moving a row that is contained in the path
                                var segmentIdx = path.segments.findIndex(function (s) { return s.sheetRowId === sheetRow.id; });
                                var parentPath = (_a = path.segments[segmentIdx - 1]) === null || _a === void 0 ? void 0 : _a.fullPath;
                                if (segmentIdx === -1 || !parentPath) {
                                    return;
                                }
                                navigate('/sheet/' + parentPath);
                            },
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        createSheetRow: createSheetRow,
        editSheetRow: update.mutateAsync,
        deleteSheetRow: remove.mutateAsync,
        duplicateSheetRow: duplicate.mutateAsync,
        createSheetRowTag: createSheetRowTag,
        selectSheetRowTag: selectSheetRowTag,
        removeSheetRowTag: removeSheetRowTag,
        dndReorderSheetRows: dndReorderSheetRows,
        dndChangeSheetRowParent: dndChangeSheetRowParent,
        batchUpdate: batchUpdate,
        materialize: materialize.mutate,
    };
}
